module.exports = __webpack_public_path__ + "media/customizations/regencyathollysprings/logo-2321fe6a2d90abb160fb6ebf29b8ff4e.png";